import styled from '@emotion/styled';
import { BREAKPOINTS, GUTTER } from '../../utils/consts';

const GridContainer = styled.div(props => {
  let fGutter = props.config?.layout?.GUTTER || GUTTER;
  let columnGutter = props.columnGutter === undefined ? fGutter : props.columnGutter;
  let rowGutter = props.rowGutter === undefined ? fGutter : props.rowGutter;

  let style = {
    display:'grid',
    marginTop: props.listSpacing !== undefined ? props.listSpacing : 20,
    gridTemplateColumns: 'repeat('+(props.desktopQty || 12)+', 1fr)',
    gridColumnGap:columnGutter,
    gridRowGap:rowGutter,
    width: '100%',
  };

  style[`@media (max-width: ${BREAKPOINTS.TABLET_PORTRAIT}px)`] = {
    gridTemplateColumns: 'repeat('+(props.tabletQty || 2)+', 1fr)',
    gridRowGap: props.rowGutterTablet || rowGutter,
  }

  style[`@media (max-width: ${BREAKPOINTS.PHONE}px)`] = {
    gridTemplateColumns: 'repeat('+(props.phoneQty || 1)+', 1fr)',
    gridColumnGap: 10,
  }

  return style;
})

export default GridContainer;